import React, { useState, useContext } from 'react';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import {FoliosContext} from "App/Administracion/Folios/store";
import {LayoutContext} from "App/Layout/store";
import ConvertXML from 'xml-js';
import axios from 'axios';
import _ from 'underscore';

const styles = theme => ({
  table: {
    marginTop: 30,
  },
  gridContainer: {
    paddingRight: 30,
    marginTop: "0.1px"
  },
  borderRed: {
    borderStyle: "solid",
    marginTop: "0.1px",
    padding: 10,
    borderColor: "red"
  },
  labelPaddingTop: {
    paddingTop: "10px"
  }
});

function AgergarFolios(props) {
    const foliosContext = useContext(FoliosContext);
    var layoutContext = useContext(LayoutContext);
    const handleToggleModal = ()=> {
        foliosContext.dispatch({type:"toggleAgregarFolio"});
        foliosContext.dispatch({type:"reset"});
    }
    const { classes } = props;

    function resolverTipoDoc(tipoDocumento) {
        var tipoDoc = _.findWhere(layoutContext.state.tiposDoc, { ID: parseInt(tipoDocumento) });
        return tipoDoc? tipoDoc.Nombre : "Desconocido";
    }

    function onFileInputChange(event) {
        event.preventDefault();
        const _validFileExtensions = [".xml", ".txt"];
        var fileInput = event.target;
        var file = fileInput.files[0];

        if(file != null) {
            var sFileName = file.name;
            var blnValid = false;
            for (var j = 0; j < _validFileExtensions.length; j++) {
                var sCurExtension = _validFileExtensions[j];
                if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }
            
            if (!blnValid) {
                alert("Sólo se aceptan archivos de tipo XML o texto");
                return false;
            }

            var reader = new FileReader();

            // Closure to capture the file information.
            reader.onload = function(e) {
                // Render thumbnail.
                var xml = e.target.result;
                var json = ConvertXML.xml2js(xml, {compact: true});
                
                var addFile = true;

                var stateFiles = foliosContext.state.foliosFiles;
                for(var i = 0; i < stateFiles.length; i++) {
                    if (stateFiles[i].idTipoDocumento ==  json.AUTORIZACION.CAF.DA.TD._text && stateFiles[i].desde == json.AUTORIZACION.CAF.DA.RNG.D._text && stateFiles[i].hasta == json.AUTORIZACION.CAF.DA.RNG.H._text) {
                        addFile = false
                        break;
                    }
                }
                
                if (addFile) {
                    var finalJson = {
                        rutReceptor: json.AUTORIZACION.CAF.DA.RE._text,
                        nombreReceptor: json.AUTORIZACION.CAF.DA.RS._text,
                        idTipoDocumento: json.AUTORIZACION.CAF.DA.TD._text,
                        tipoDocumento: resolverTipoDoc(json.AUTORIZACION.CAF.DA.TD._text),
                        fechaAutorizacion: json.AUTORIZACION.CAF.DA.FA._text,
                        desde: json.AUTORIZACION.CAF.DA.RNG.D._text,
                        hasta: json.AUTORIZACION.CAF.DA.RNG.H._text
                    }
                    foliosContext.dispatch({type:"agregarFolio", folio: finalJson, folioXml: xml.toString()});
                    fileInput.value = "";
                } else {
                    alert("Archivo de folios previamente ingresado");
                    fileInput.value = "";
                }
            };

            reader.readAsText(file);
        }
    }

    function GuardarFolios() {
        if(foliosContext.state.foliosXml.length > 0) {
            var listFolios = {
                folios: foliosContext.state.foliosXml
            }
            axios.post('/api/Administracion/Folio/Agregar', listFolios).then(()=> {
                alert("Folios cargados con éxito");
                handleToggleModal();
            }).catch((e)=> {
                console.log(e.response.data.Mensaje);
                /*alert(e.response.data.Mensaje)*/;
            })
        } else {
            alert("No hay folios para cargar en el sistema");
        }
    }

    function QuitarFolio(index) {
        foliosContext.dispatch({ type:"quitarFolio", index });
    }

    const content = (
        <Grid container direction="column">
            <Grid item xs={12} sm>
                <Button variant="contained"
                    containerElement='label' // <-- Just add me!
                    label='My Label'>
                    <input onChange={onFileInputChange} type="file" />
                </Button>
            </Grid>
            <Grid item xs={12} sm>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Tipo de documento</TableCell>
                            <TableCell>Rut Receptor</TableCell>
                            <TableCell>Nombre Receptor</TableCell>
                            <TableCell>Fecha de autorización</TableCell>
                            <TableCell numeric>Desde</TableCell>
                            <TableCell numeric>Hasta</TableCell>
                            <TableCell>Quitar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(foliosContext ? (foliosContext.state.foliosFiles || []) : []).map((folio, ix) => {
                            var deleteButton = (index) => {
                                return (
                                    <Button onClick={()=> { QuitarFolio(index) }}><Icon>remove_circle</Icon></Button>
                                )
                            };
                            return (
                            <TableRow key={ix}>
                                <TableCell>{folio.tipoDocumento}</TableCell>
                                <TableCell>{folio.rutReceptor}</TableCell>
                                <TableCell>{folio.nombreReceptor}</TableCell>
                                <TableCell>{folio.fechaAutorizacion}</TableCell>
                                <TableCell numeric>{folio.desde}</TableCell>
                                <TableCell numeric>{folio.hasta}</TableCell>
                                <TableCell>{deleteButton(ix)}</TableCell>
                            </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    );

    const footer = (
        <DialogActions>
        <Button onClick={handleToggleModal} color="primary">
            Cancelar
        </Button>
        <Button onClick={()=> { GuardarFolios(); }} color="primary" autoFocus>
            Guardar
        </Button>
        </DialogActions>
    );

    return (
        <div>
        <CloseButtonDialog open={foliosContext.state.openAgregarFolios} onClose={handleToggleModal} closeButton title={"Cargar folios"} content={content} footer={footer} fullWidth fullHeight size="lg" />
        </div>
    );
}

export default withStyles(styles)(AgergarFolios);